/** @file PNG decode caps: the Worker's 2048 px upload limit (spec §8.7) and the default for any other caller. */

/**
 * `maxSide` is the longest side in px, `maxPixels` is width × height. `upload` is what the Worker stores (2048 px a
 * side); `default` (decodePng without options) covers Pose2D's own renders and 4096² export pages.
 */
export const PNG_LIMITS = {
  upload: { maxSide: 2048, maxPixels: 4194304 },
  default: { maxSide: 16384, maxPixels: 16777216 },
} as const;
